import { callApi } from '@local_modules/generic/fetch.js'

export async function inviteCreate (browserAppAccount) {
  const invitedEmailElement = document.getElementById('invitedEmail')
  const invitedEmail = invitedEmailElement.value
  console.log('invitedEmail', invitedEmail)

  await executeApiCall(browserAppAccount, invitedEmail)
}

/**
 *
 * @param {Object} browserAppAccount
 * @param {String} invitedEmail
 */
async function executeApiCall (browserAppAccount, invitedEmail) {
  const data = {
    email: invitedEmail,
    appAccountId: browserAppAccount.data.appAccountId,
    rights: ['canView']
  }
  const apiUrl = '/api/user-invites/create'
  await callApi(apiUrl, null, {
    method: 'POST',
    body: JSON.stringify(data)
  })
}
